import { initialPropsExperimentConfig } from '@retail/funnel-components';

/**
 * @type {import('@retail/funnel-components/types/buildConfig/types').ICarleadCreationAppConfig}
 */
export const funnelOptions = {
  trackLandingPageType: 'lead',
  emailSuggestionEnabled: true,
  redirectOnSuccessUrl: '/es/booking/{hash}/',
  featuresFlags: {
    postalCode: false,
    honeyPotEmail: false,
    redirectToSelfEvaluation: true,
    selfEvaHideOnlinePriceBucket: true,
    dropOffEmailDelayInMinutes: 20,
  },
  abExperiment: initialPropsExperimentConfig.carleadCreation,
  minimumMileage: true,
  pageName: 'sellCar',
  marketingAttributes: {
    'lead-conversational-lead-toggle': 0,
  },
  hreflangLinks: [
    { locale: 'de-AT', path: '/at/auto-verkaufen/' },
    { locale: 'de-DE', path: '/de/auto-verkaufen/' },
    { locale: 'sv-SE', path: '/se/salja-bil/' },
    { locale: 'fr-BE', path: '/fr-be/vendre-sa-voiture/' },
    { locale: 'fr-FR', path: '/fr/vendre-sa-voiture/' },
    { locale: 'it-IT', path: '/it/vendere-auto/' },
    { locale: 'es-ES', path: '/es/vendo-coche/' },
    { locale: 'nl-BE', path: '/nl-be/auto-verkopen/' },
    { locale: 'nl-NL', path: '/nl/auto-verkopen/' },
  ],
};
